/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Toggle = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.5 2.5H18.5C20.1569 2.5 21.5 4.34315 21.5 6C21.5 7.65685 20.1569 9.5 18.5 9.5H5.5C3.84315 9.5 2.5 7.65685 2.5 6C2.5 4.34315 3.84315 2.5 5.5 2.5ZM1 6C1 3.51472 3.01472 1 5.5 1H18.5C20.9853 1 23 3.51472 23 6C23 8.48528 20.9853 11 18.5 11H5.5C3.01472 11 1 8.48528 1 6ZM18.5 14.5H5.5C3.84315 14.5 2.5 16.3431 2.5 18C2.5 19.6569 3.84315 21.5 5.5 21.5H18.5C20.1569 21.5 21.5 19.6569 21.5 18C21.5 16.3431 20.1569 14.5 18.5 14.5ZM5.5 13C3.01472 13 1 15.5147 1 18C1 20.4853 3.01472 23 5.5 23H18.5C20.9853 23 23 20.4853 23 18C23 15.5147 20.9853 13 18.5 13H5.5ZM6.5 7.5C7.32843 7.5 8 6.82843 8 6C8 5.17157 7.32843 4.5 6.5 4.5C5.67157 4.5 5 5.17157 5 6C5 6.82843 5.67157 7.5 6.5 7.5ZM6.5 9C8.15685 9 9.5 7.65685 9.5 6C9.5 4.34315 8.15685 3 6.5 3C4.84315 3 3.5 4.34315 3.5 6C3.5 7.65685 4.84315 9 6.5 9ZM19 18C19 18.8284 18.3284 19.5 17.5 19.5C16.6716 19.5 16 18.8284 16 18C16 17.1716 16.6716 16.5 17.5 16.5C18.3284 16.5 19 17.1716 19 18ZM20.5 18C20.5 19.6569 19.1569 21 17.5 21C15.8431 21 14.5 19.6569 14.5 18C14.5 16.3431 15.8431 15 17.5 15C19.1569 15 20.5 16.3431 20.5 18Z"
                        fill={color}
                    />
                </svg>
        );
    };
